import { render } from "./HeroiconsSolidPresentationChartLine.vue?vue&type=template&id=57cc807d"
const script = {}

import exportComponent from "/Users/mq/Projects/siinadmin/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidPresentationChartLine.vue"]])

export default __exports__